/**
 * @generated SignedSource<<007593166bedea6758f6841be57669be>>
 * @relayHash 5b529092e8e7cf6e323eeab66137e3bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c229ae6e5818fbecf2bb0804d73eba2602d664fa5e34d0c1a4ba786d8eaa39f8

import type { ConcreteRequest } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type CommentQueryParamsListenerQuery$variables = {
  commentId: string;
};
export type CommentQueryParamsListenerQuery$data = {
  readonly comments: {
    readonly nodes: ReadonlyArray<{
      readonly ancestors: ReadonlyArray<{
        readonly author: {
          readonly accountId?: string | null | undefined;
          readonly displayName: string | null | undefined;
          readonly permissionType: SitePermissionType | null | undefined;
          readonly profilePicture: {
            readonly path: string;
          } | null | undefined;
        };
        readonly id: string;
        readonly location: {
          readonly inlineMarkerRef?: string | null | undefined;
          readonly inlineResolveProperties?: {
            readonly resolved: boolean;
          } | null | undefined;
          readonly type: string;
        };
      } | null | undefined>;
      readonly author: {
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly permissionType: SitePermissionType | null | undefined;
        readonly profilePicture: {
          readonly path: string;
        } | null | undefined;
      };
      readonly id: string;
      readonly location: {
        readonly commentResolveProperties?: {
          readonly resolved: boolean;
        } | null | undefined;
        readonly inlineMarkerRef?: string | null | undefined;
        readonly inlineResolveProperties?: {
          readonly resolved: boolean;
        } | null | undefined;
        readonly type: string;
      };
      readonly parentId: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type CommentQueryParamsListenerQuery = {
  response: CommentQueryParamsListenerQuery$data;
  variables: CommentQueryParamsListenerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "commentId",
    "variableName": "commentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v4 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v5 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v8 = {
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/)
  ]
},
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = [
  {
    "kind": "ScalarField",
    "name": "resolved"
  }
],
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "inlineMarkerRef"
    },
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "inlineResolveProperties",
      "plural": false,
      "selections": (v10/*: any*/)
    }
  ],
  "type": "InlineComment"
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "commentResolveProperties",
      "plural": false,
      "selections": (v10/*: any*/)
    }
  ],
  "type": "FooterComment"
},
v13 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v14 = {
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CommentQueryParamsListenerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ]
              },
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v11/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentQueryParamsListenerQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v14/*: any*/),
              {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v9/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ]
              },
              {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v14/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      (v9/*: any*/),
                      (v11/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "5b529092e8e7cf6e323eeab66137e3bd",
    "id": "c229ae6e5818fbecf2bb0804d73eba2602d664fa5e34d0c1a4ba786d8eaa39f8",
    "metadata": {},
    "name": "CommentQueryParamsListenerQuery",
    "operationKind": "query",
    "text": "query CommentQueryParamsListenerQuery($commentId:ID!){comments(commentId:$commentId){nodes{id,parentId,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}},...on FooterComment{commentResolveProperties{resolved}}},ancestors{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}}}}}}"
  }
};
})();

(node as any).hash = "d0febae7f259d56d6f03c22fbaa80801";

export default node;
